/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import {
  ContractorWorkerApiProps,
  ContractorWorkerParamsProps,
  CorpWorkerApiProps,
  CorpWorkerFilterParams,
  CorpWorkersApiProps,
  SendCSVApiProps,
  WorkerApiProps,
  WorkersApiProps,
  WorkerSectionFilterParams,
} from './types';
import worker from './worker';

const workerTag = baseApi.enhanceEndpoints({ addTagTypes: [worker.tagType] });
const workerAPi = workerTag.injectEndpoints({
  endpoints: (builder) => ({
    getWorkers: builder.query<WorkersApiProps, number>(
      worker.getEntitiesWithId('contractors'),
    ),
    getContractorWorkers: builder.query<ContractorWorkerApiProps, ContractorWorkerParamsProps>(
      worker.getContractorWorkers(),
    ),
    getWorker: builder.query<WorkerApiProps, number>(worker.getEntity()),
    addWorker: builder.mutation<WorkerApiProps, Partial<WorkerApiProps>>(
      worker.addEntity('contractors'),
    ),
    importContractorWorker: builder.mutation<WorkerApiProps, Pick<WorkerApiProps, 'id'> & Partial<WorkerApiProps>>(
      worker.importContractorWorker(),
    ),
    updateWorker: builder.mutation<void, Pick<WorkerApiProps, 'id'> & Partial<WorkerApiProps>>(worker.updateEntity()),
    downloadContractorWorkersImportTemplate: builder.mutation<Blob, number>(
      worker.downloadContractorWorkersImportTemplate(),
    ),
    deleteWorker: builder.mutation<{ success: boolean; id: number }, number>(
      worker.deleteEntity(),
    ),
    deleteContractorWorker: builder.mutation<{ success: boolean; id: number }, number>(
      worker.deleteContractorWorker(),
    ),
    deleteAllWorkers: builder.mutation<{ success: boolean; id: number }, number>(
      worker.deleteEntityAll('contractors'),
    ),
    sendWorkersCSV: builder.mutation<SendCSVApiProps, Partial<SendCSVApiProps>>(
      worker.sendReport('user-reports'),
    ),
    getSectionWorkers: builder.query<ContractorWorkerApiProps, WorkerSectionFilterParams>(
      worker.getSectionWorkers(),
    ),
    getCorpWorkers: builder.query<CorpWorkersApiProps, CorpWorkerFilterParams | undefined>(
      worker.getCorpWorkers(),
    ),
    createCorpWorker: builder.mutation<CorpWorkerApiProps, Partial<CorpWorkerApiProps>>(
      worker.createCorpWorker(),
    ),
    updateCorpWorker: builder.mutation<CorpWorkerApiProps, Pick<CorpWorkerApiProps, 'id'> & Partial<CorpWorkerApiProps>>(
      worker.updateCorpWorker(),
    ),
    getContractorWorkersRut: builder.query<ContractorWorkerApiProps,
     ContractorWorkerParamsProps>(
       worker.getContractorWorkersRutQuery(),
     ),
    getCorpWorker: builder.query<CorpWorkersApiProps, number>(
      worker.getCorpWorker(),
    ),
  }),
  overrideExisting: false,
});

export const {
  useAddWorkerMutation,
  useImportContractorWorkerMutation,
  useDeleteWorkerMutation,
  useGetWorkerQuery,
  useGetWorkersQuery,
  useGetContractorWorkersQuery,
  useGetCorpWorkersQuery,
  useGetCorpWorkerQuery,
  useUpdateWorkerMutation,
  useDownloadContractorWorkersImportTemplateMutation,
  useSendWorkersCSVMutation,
  useDeleteAllWorkersMutation,
  useGetSectionWorkersQuery,
  useDeleteContractorWorkerMutation,
  useCreateCorpWorkerMutation,
  useUpdateCorpWorkerMutation,
  useGetContractorWorkersRutQuery,
} = workerAPi;
